import React from 'react'
import { UserAccessState } from '@caudena/core/states/UserAcessState'
import { NotificationsController } from '../controllers'
import { settingsController } from '../controllers/SettingsController'
import { settingsState } from '../states'
import type { IPhoenixSocketController } from '@caudena/api/WebSocket'
import { DI_TYPES } from '@caudena/api/DI/types'
import { phoenixSocketControllerContainer } from '@caudena/api/DI/socketControllerModule'

interface AppCtxInit {
  token: string
  wss?: string
  refreshToken: () => Promise<string>
}

export class AppCtx {
  public wsState =
    phoenixSocketControllerContainer.get<IPhoenixSocketController>(
      DI_TYPES.PhoenixSocketController
    )
  public userState = new UserAccessState()
  public settingsController = settingsController
  public settingsState = settingsState

  public init = async ({ token, wss, refreshToken }: AppCtxInit) => {
    if (wss) {
      this.wsState.init({ token, wss, userState: this.userState, refreshToken })
      await this.settingsController.loadAndStoreSettingsProfile()
      const notificationsController = new NotificationsController({
        webSocketState: this.wsState,
        settingsController: this.settingsController,
      })
      notificationsController.init()
    }
  }
  public reconnectWithNewToken = async (token: string, logout: () => void) => {
    await this.wsState.reconnectWithNewToken(token, logout)
  }
}

export const ctx = new AppCtx()
export const createAppCtx = React.createContext(ctx)
export const useAppCtx = () => React.useContext(createAppCtx)
